'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AUM = function (_React$Component) {
  _inherits(AUM, _React$Component);

  function AUM() {
    _classCallCheck(this, AUM);

    return _possibleConstructorReturn(this, (AUM.__proto__ || Object.getPrototypeOf(AUM)).apply(this, arguments));
  }

  _createClass(AUM, [{
    key: 'displayAsOfDate',
    value: function displayAsOfDate() {
      if (this.props.aum && this.props.aum.netAsset) {
        return _react2.default.createElement(
          'div',
          null,
          _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of", { role: this.props.role }),
          _react2.default.createElement(
            'span',
            null,
            _date_formatter2.default.getDateInSlashFormat(this.props.aum.date)
          )
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _ramda.isNil)(this.props.aum)) {
        return null;
      }
      var is529OrPMF = this.props.fundTypeCode === '529 Plans' || this.props.fundTypeCode === 'Tender Offer Fund';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'tag font-black-variant', 'data-testid': 'fund-asset' },
            is529OrPMF ? 'PORTFOLIO ASSETS' : 'FUND ASSETS'
          ),
          _react2.default.createElement(
            'div',
            { className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "disclaimer", "category") + ' font-slate-grey', 'data-testid': 'aum-as-of-date' },
            this.displayAsOfDate()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-5 margin-right-10' },
          _react2.default.createElement(
            'span',
            { className: 'display-block disclaimer font-black-variant' },
            '\xA0'
          ),
          _react2.default.createElement(
            'span',
            { className: 'display-block ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2") + ' font-black-variant', 'data-testid': 'aum-netAsset' },
            _currency_utility2.default.convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(this.props.aum.netAsset, this.props.currencyCode)
          )
        )
      );
    }
  }]);

  return AUM;
}(_react2.default.Component);

exports.default = AUM;